﻿{
  "icons": [
    "access-point-network",
    "access-point",
    "account-alert",
    "account-box-outline",
    "account-box",
    "account-card-details",
    "account-check",
    "account-circle",
    "account-convert",
    "account-key",
    "account-location",
    "account-minus",
    "account-multiple-minus",
    "account-multiple-outline",
    "account-multiple-plus",
    "account-multiple",
    "account-network",
    "account-off",
    "account-outline",
    "account-plus",
    "account-remove",
    "account-search",
    "account-settings-variant",
    "account-settings",
    "account-switch",
    "account",
    "adjust",
    "air-conditioner",
    "airballoon",
    "airplane-landing",
    "airplane-off",
    "airplane-takeoff",
    "airplane",
    "airplay",
    "alarm-check",
    "alarm-multiple",
    "alarm-off",
    "alarm-plus",
    "alarm-snooze",
    "alarm",
    "album",
    "alert-box",
    "alert-circle-outline",
    "alert-circle",
    "alert-octagon",
    "alert-outline",
    "alert",
    "all-inclusive",
    "alpha",
    "alphabetical",
    "altimeter",
    "amazon-clouddrive",
    "amazon",
    "ambulance",
    "amplifier",
    "anchor",
    "android-debug-bridge",
    "android-studio",
    "android",
    "angular",
    "angularjs",
    "animation",
    "animation-play-outline",
    "apple-finder",
    "apple-ios",
    "apple-keyboard-caps",
    "apple-keyboard-command",
    "apple-keyboard-control",
    "apple-keyboard-option",
    "apple-keyboard-shift",
    "apple-mobileme",
    "apple-safari",
    "apple",
    "application",
    "appnet",
    "apps",
    "archive",
    "arrange-bring-forward",
    "arrange-bring-to-front",
    "arrange-send-backward",
    "arrange-send-to-back",
    "arrow-all",
    "arrow-bottom-left",
    "arrow-bottom-right",
    "arrow-compress-all",
    "arrow-compress",
    "arrow-down-bold-circle-outline",
    "arrow-down-bold-circle",
    "arrow-down-bold-hexagon-outline",
    "arrow-down-bold",
    "arrow-down-box",
    "arrow-down-drop-circle-outline",
    "arrow-down-drop-circle",
    "arrow-down-drop",
    "arrow-down",
    "arrow-expand-all",
    "arrow-expand",
    "arrow-expand-horizontal",
    "arrow-left-bold-circle-outline",
    "arrow-left-bold-circle",
    "arrow-left-bold-hexagon-outline",
    "arrow-left-bold",
    "arrow-left-box",
    "arrow-left-drop-circle-outline",
    "arrow-left-drop-circle",
    "arrow-left",
    "arrow-right-bold-circle-outline",
    "arrow-right-bold-circle",
    "arrow-right-bold-hexagon-outline",
    "arrow-right-bold",
    "arrow-right-box",
    "arrow-right-drop-circle-outline",
    "arrow-right-drop-circle",
    "arrow-right",
    "arrow-top-left",
    "arrow-top-right",
    "arrow-up-bold-circle-outline",
    "arrow-up-bold-circle",
    "arrow-up-bold-hexagon-outline",
    "arrow-up-bold",
    "arrow-up-box",
    "arrow-up-drop-circle-outline",
    "arrow-up-drop-circle",
    "arrow-up",
    "assistant",
    "asterisk",
    "at",
    "attachment",
    "audiobook",
    "auto-fix",
    "auto-upload",
    "autorenew",
    "av-timer",
    "baby-buggy",
    "baby",
    "backburger",
    "backspace",
    "backup-restore",
    "bandcamp",
    "bank",
    "barcode-scan",
    "barcode",
    "barley",
    "barrel",
    "basecamp",
    "basket-fill",
    "basket-unfill",
    "basket",
    "battery-10",
    "battery-20",
    "battery-30",
    "battery-40",
    "battery-50",
    "battery-60",
    "battery-70",
    "battery-80",
    "battery-90",
    "battery-alert",
    "battery-charging-100",
    "battery-charging-20",
    "battery-charging-30",
    "battery-charging-40",
    "battery-charging-60",
    "battery-charging-80",
    "battery-charging-90",
    "battery-charging",
    "battery-minus",
    "battery-negative",
    "battery-outline",
    "battery-plus",
    "battery-positive",
    "battery-standard",
    "battery-unknown",
    "battery",
    "beach",
    "beaker",
    "beats",
    "beer",
    "behance",
    "bell-off",
    "bell-outline",
    "bell-plus",
    "bell-ring-outline",
    "bell-ring",
    "bell-sleep",
    "bell",
    "beta",
    "bible",
    "bike",
    "bing",
    "binoculars",
    "bio",
    "bitbucket",
    "black-mesa",
    "blackberry",
    "blender",
    "blinds",
    "block-helper",
    "blogger",
    "bluetooth-audio",
    "bluetooth-connect",
    "bluetooth-off",
    "bluetooth-settings",
    "bluetooth-transfer",
    "bluetooth",
    "blur-linear",
    "blur-off",
    "blur-radial",
    "blur",
    "bomb-off",
    "bomb",
    "bone",
    "book-minus",
    "book-multiple-variant",
    "book-multiple",
    "book-open-page-variant",
    "book-open-variant",
    "book-open",
    "book-plus",
    "book-variant",
    "book",
    "bookmark-check",
    "bookmark-music",
    "bookmark-outline-plus",
    "bookmark-outline",
    "bookmark-plus",
    "bookmark-remove",
    "bookmark",
    "boombox",
    "bootstrap",
    "border-all",
    "border-bottom",
    "border-color",
    "border-horizontal",
    "border-inside",
    "border-left",
    "border-none",
    "border-outside",
    "border-right",
    "border-style",
    "border-top",
    "border-vertical",
    "bow-tie",
    "bowl",
    "bowling",
    "box-cutter",
    "box-download",
    "box-shadow",
    "box-upload",
    "box",
    "bridge",
    "briefcase-checked",
    "briefcase-download",
    "briefcase-upload",
    "briefcase",
    "brightness-1",
    "brightness-2",
    "brightness-3",
    "brightness-4",
    "brightness-5",
    "brightness-6",
    "brightness-7",
    "brightness-auto",
    "brightness",
    "broom",
    "brush",
    "buffer",
    "bug",
    "bulletin-board",
    "bullhorn",
    "bullseye",
    "burst-mode",
    "bus",
    "cached",
    "cake-layered",
    "cake-variant",
    "cake",
    "calculator-off",
    "calculator",
    "calendar-blank",
    "calendar-check-multiple",
    "calendar-check",
    "calendar-clock",
    "calendar-multiple",
    "calendar-plus",
    "calendar-question",
    "calendar-range",
    "calendar-remove",
    "calendar-select",
    "calendar-text",
    "calendar-today",
    "calendar",
    "call-made",
    "call-merge",
    "call-missed",
    "call-received",
    "call-split",
    "camcorder-box-off",
    "camcorder-box",
    "camcorder-off",
    "camcorder",
    "camera-burst",
    "camera-enhance",
    "camera-front-variant",
    "camera-front",
    "camera-iris",
    "camera-off",
    "camera-party-mode",
    "camera-rear-variant",
    "camera-rear",
    "camera-switch",
    "camera-timer",
    "camera",
    "cancel",
    "candle",
    "candycane",
    "car-battery",
    "car-connected",
    "car-wash",
    "car",
    "cards-outline",
    "cards-playing-outline",
    "cards-variant",
    "cards",
    "carrot",
    "cart-off",
    "cart-outline",
    "cart-plus",
    "cart",
    "cash-100",
    "cash-multiple",
    "cash-usd",
    "cash",
    "cast-connected",
    "cast",
    "castle",
    "cat",
    "cellphone-android",
    "cellphone-basic",
    "cellphone-dock",
    "cellphone-iphone",
    "cellphone-link-off",
    "cellphone-link",
    "cellphone-settings",
    "cellphone",
    "certificate",
    "chair-school",
    "chart-arc",
    "chart-areaspline",
    "chart-bar",
    "chart-bubble",
    "chart-gantt",
    "chart-histogram",
    "chart-line",
    "chart-pie",
    "chart-scatterplot-hexbin",
    "chart-timeline",
    "check-all",
    "check-bookmark",
    "check-circle-outline",
    "check-circle",
    "check",
    "checkbox-blank-circle-outline",
    "checkbox-blank-circle",
    "checkbox-blank-outline",
    "checkbox-blank",
    "checkbox-marked-circle-outline",
    "checkbox-marked-circle",
    "checkbox-marked-outline",
    "checkbox-marked",
    "checkbox-multiple-blank-circle-outline",
    "checkbox-multiple-blank-circle",
    "checkbox-multiple-blank-outline",
    "checkbox-multiple-blank",
    "checkbox-multiple-marked-circle-outline",
    "checkbox-multiple-marked-circle",
    "checkbox-multiple-marked-outline",
    "checkbox-multiple-marked",
    "checkerboard",
    "chemical-weapon",
    "chevron-double-down",
    "chevron-double-left",
    "chevron-double-right",
    "chevron-double-up",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "chip",
    "church",
    "cisco-webex",
    "city",
    "clapperboard",
    "clipboard-account",
    "clipboard-alert",
    "clipboard-arrow-down",
    "clipboard-arrow-left",
    "clipboard-check",
    "clipboard-flow",
    "clipboard-outline",
    "clipboard-text",
    "clipboard",
    "clippy",
    "clock-alert",
    "clock-end",
    "clock-fast",
    "clock-in",
    "clock-out",
    "clock-start",
    "clock",
    "close-circle-outline",
    "close-circle",
    "close-network",
    "close-octagon-outline",
    "close-octagon",
    "close-outline",
    "close",
    "closed-caption",
    "cloud-check",
    "cloud-circle",
    "cloud-download",
    "cloud-outline-off",
    "cloud-outline",
    "cloud-print-outline",
    "cloud-print",
    "cloud-sync",
    "cloud-upload",
    "cloud",
    "code-array",
    "code-braces",
    "code-brackets",
    "code-equal",
    "code-greater-than-or-equal",
    "code-greater-than",
    "code-less-than-or-equal",
    "code-less-than",
    "code-not-equal-variant",
    "code-not-equal",
    "code-parentheses",
    "code-string",
    "code-tags-check",
    "code-tags",
    "codepen",
    "coffee-outline",
    "coffee-to-go",
    "coffee",
    "coin",
    "coins",
    "collage",
    "color-helper",
    "comment-account-outline",
    "comment-account",
    "comment-alert-outline",
    "comment-alert",
    "comment-check-outline",
    "comment-check",
    "comment-multipe-outline",
    "comment-outline",
    "comment-plus-outline",
    "comment-processing-outline",
    "comment-processing",
    "comment-question-outline",
    "comment-remove-outline",
    "comment-text-outline",
    "comment-text",
    "comment",
    "compare",
    "compass-outline",
    "compass",
    "console",
    "contact-mail",
    "contacts",
    "content-copy",
    "content-cut",
    "content-duplicate",
    "content-paste",
    "content-save-all",
    "content-save-outline",
    "content-save-settings",
    "content-save",
    "contrast-box",
    "contrast-circle",
    "contrast",
    "controller-xbox",
    "cookie",
    "copyright",
    "counter",
    "cow",
    "creation",
    "credit-card-multiple",
    "credit-card-off",
    "credit-card-plus",
    "credit-card-scan",
    "credit-card",
    "crop-free",
    "crop-landscape",
    "crop-portrait",
    "crop-rotate",
    "crop-square",
    "crop",
    "crosshairs-gps",
    "crosshairs",
    "crown",
    "cube-outline",
    "cube-send",
    "cube-unfolded",
    "cube",
    "cup-off",
    "cup-water",
    "cup",
    "currency-btc",
    "currency-eur",
    "currency-gbp",
    "currency-inr",
    "currency-ngn",
    "currency-rub",
    "currency-try",
    "currency-usd-off",
    "currency-usd",
    "cursor-default-outline",
    "cursor-default",
    "cursor-move",
    "cursor-pointer",
    "cursor-text",
    "data",
    "database-minus",
    "database-plus",
    "database",
    "debug-step-into",
    "debug-step-out",
    "debug-step-over",
    "decimal-decrease",
    "decimal-increase",
    "delete-circle",
    "delete-empty",
    "delete-forever",
    "delete-sweep",
    "delete-variant",
    "delete",
    "delta",
    "deskphone",
    "desktop-mac",
    "desktop-tower",
    "details",
    "developer-board",
    "deviantart",
    "dialpad",
    "diamond",
    "dice-1",
    "dice-2",
    "dice-3",
    "dice-4",
    "dice-5",
    "dice-6",
    "dice-d20",
    "dice-d4",
    "dice-d6",
    "dice-d8",
    "dice",
    "dictionary",
    "directions-fork",
    "directions",
    "discord",
    "disk-alert",
    "disk",
    "disqus-outline",
    "disqus",
    "division-box",
    "division",
    "dna",
    "dns",
    "do-not-disturb-off",
    "do-not-disturb",
    "document",
    "dolby",
    "domain",
    "dots-horizontal",
    "dots-vertical",
    "douban",
    "download",
    "drag-horizontal",
    "drag-vertical",
    "drag",
    "drawing-box",
    "drawing",
    "dribbble-box",
    "dribbble",
    "drone",
    "dropbox",
    "drupal",
    "duck",
    "dumbbell",
    "earth-box-off",
    "earth-box",
    "earth-off",
    "earth",
    "ebay",
    "edge",
    "eject",
    "elevation-decline",
    "elevation-rise",
    "elevator",
    "email-alert",
    "email-open-outline",
    "email-open",
    "email-outline",
    "email-secure",
    "email-variant",
    "email",
    "emby",
    "emoticon-cool",
    "emoticon-dead",
    "emoticon-devil",
    "emoticon-excited",
    "emoticon-happy",
    "emoticon-neutral",
    "emoticon-poop",
    "emoticon-sad",
    "emoticon-tongue",
    "emoticon",
    "engine-outline",
    "engine",
    "equal-box",
    "equal",
    "eraser-variant",
    "eraser",
    "escalator",
    "ethernet-cable-off",
    "ethernet-cable",
    "ethernet",
    "etsy",
    "ev-station",
    "evernote",
    "exclamation",
    "exit-to-app",
    "export",
    "eye-off",
    "eye-outline-off",
    "eye-outline",
    "eye",
    "eyedropper-variant",
    "eyedropper",
    "face-profile",
    "face",
    "facebook-box",
    "facebook-messenger",
    "facebook",
    "factory",
    "fan",
    "fast-forward-outline",
    "fast-forward",
    "fax",
    "feather",
    "ferry",
    "file-chart",
    "file-check",
    "file-cloud",
    "file-delimited",
    "file-document-box",
    "file-document",
    "file-excel-box",
    "file-excel",
    "file-export",
    "file-find",
    "file-hidden",
    "file-image-box",
    "file-image",
    "file-import",
    "file-lock",
    "file-move",
    "file-multiple",
    "file-music",
    "file-outline",
    "file-pdf-box",
    "file-pdf",
    "file-powerpoint-box",
    "file-powerpoint",
    "file-presentation-box",
    "file-restore",
    "file-send",
    "file-tree",
    "file-video",
    "file-word-box",
    "file-word",
    "file-xml",
    "file",
    "fill",
    "film",
    "filmstrip-off",
    "filmstrip",
    "filter-outline",
    "filter-remove-outline",
    "filter-remove",
    "filter-variant",
    "filter",
    "fingerprint",
    "fire",
    "fish",
    "flag-checkered-variant",
    "flag-checkered",
    "flag-outline-variant",
    "flag-outline",
    "flag-triangle",
    "flag-variant",
    "flag",
    "flash-auto",
    "flash-off",
    "flash-outline",
    "flash-red-eye",
    "flash",
    "flashlight-off",
    "flashlight",
    "flask-empty-outline",
    "flask-empty",
    "flask-outline",
    "flask",
    "flattr",
    "flickr-after",
    "flickr-before",
    "flip-to-back",
    "flip-to-front",
    "floppy",
    "flower",
    "folder-account",
    "folder-download",
    "folder-google-drive",
    "folder-image",
    "folder-lock-open",
    "folder-lock",
    "folder-move",
    "folder-multiple-image",
    "folder-multiple-outline",
    "folder-multiple",
    "folder-open",
    "folder-outline-lock",
    "folder-outline",
    "folder-plus",
    "folder-remove",
    "folder-star",
    "folder-upload",
    "folder",
    "food-apple",
    "food-fork-drink",
    "food-off",
    "food-variant",
    "food",
    "football-australian",
    "football-helmet",
    "football",
    "format-align-center",
    "format-align-justify",
    "format-align-left",
    "format-align-right",
    "format-annotation-plus",
    "format-bold",
    "format-clear",
    "format-color-fill",
    "format-color-text",
    "format-color",
    "format-float-center",
    "format-float-left",
    "format-float-none",
    "format-float-right",
    "format-font",
    "format-header-1",
    "format-header-2",
    "format-header-3",
    "format-header-4",
    "format-header-5",
    "format-header-6",
    "format-header-decrease",
    "format-header-down",
    "format-header-equal",
    "format-header-increase",
    "format-header-pound",
    "format-header-up",
    "format-horizontal-align-center",
    "format-horizontal-align-left",
    "format-horizontal-align-right",
    "format-indent-decrease",
    "format-indent-increase",
    "format-italic",
    "format-line-spacing",
    "format-line-style",
    "format-line-weight",
    "format-list-bulleted-type",
    "format-list-bulleted",
    "format-list-numbers",
    "format-object-inline",
    "format-object-square",
    "format-object-tight",
    "format-object-top-bottom",
    "format-page-break",
    "format-paint",
    "format-paragraph",
    "format-pilcrow",
    "format-quote",
    "format-section",
    "format-size",
    "format-strikethrough-variant",
    "format-strikethrough",
    "format-subscript",
    "format-superscript",
    "format-text",
    "format-textdirection-l-to-r",
    "format-textdirection-r-to-l",
    "format-title",
    "format-underline",
    "format-vertical-align-bottom",
    "format-vertical-align-center",
    "format-vertical-align-top",
    "form-dropdown",
    "forum",
    "forward",
    "foursquare",
    "fridge-filled-bottom",
    "fridge-filled-top",
    "fridge-filled",
    "fridge",
    "fullscreen-exit",
    "fullscreen",
    "function",
    "gamepad-variant",
    "gamepad",
    "garage-open",
    "garage",
    "gas-cylinder",
    "gas-station",
    "gate",
    "gauge",
    "gavel",
    "gender-female",
    "gender-male-female",
    "gender-male",
    "gender-transgender",
    "ghost",
    "gift",
    "git",
    "github-box",
    "github-face",
    "github",
    "glass-flute",
    "glass-mug",
    "glass-stange",
    "glass-tulip",
    "glassdoor",
    "glasses",
    "gmail",
    "gnome",
    "gondola",
    "google-cardboard",
    "google-chrome",
    "google-circles-communities",
    "google-circles-extended",
    "google-circles-invite",
    "google-circles",
    "google-controller-off",
    "google-controller",
    "google-drive",
    "google-earth",
    "google-glass",
    "google-keep",
    "google-maps",
    "google-nearby",
    "google-pages",
    "google-photos",
    "google-physical-web",
    "google-play",
    "google-plus-box",
    "google-plus",
    "google-translate",
    "google-wallet",
    "google",
    "gradient",
    "grease-pencil",
    "grid-off",
    "grid",
    "group",
    "hackernews",
    "hamburger",
    "hand-pointing-right",
    "hanger",
    "hangouts",
    "harddisk",
    "headphones-box",
    "headphones-settings",
    "headphones",
    "headset-dock",
    "headset-off",
    "headset",
    "heart-box-outline",
    "heart-box",
    "heart-broken",
    "heart-half-outline",
    "heart-half-part-outline",
    "heart-half-part",
    "heart-outline",
    "heart-pulse",
    "heart",
    "help-circle-outline",
    "help-circle",
    "help",
    "hexagon-outline",
    "hexagon",
    "highway",
    "history",
    "hololens",
    "home-map-marker",
    "home-modern",
    "home-outline",
    "home-variant",
    "home",
    "hook-off",
    "hook",
    "hops",
    "hospital-building",
    "hospital-marker",
    "hospital",
    "hotel",
    "houzz-box",
    "human-child",
    "human-female",
    "human-greeting",
    "human-handsdown",
    "human-handsup",
    "human-male-female",
    "human-male",
    "human-pregnant",
    "human",
    "image-album",
    "image-area-close",
    "image-area",
    "image-broken-variant",
    "image-broken",
    "image-filter-black-white",
    "image-filter-center-focus-weak",
    "image-filter-center-focus",
    "image-filter-drama",
    "image-filter-frames",
    "image-filter-hdr",
    "image-filter-none",
    "image-filter-tilt-shift",
    "image-filter-vintage",
    "image-filter",
    "image-mutliple",
    "image",
    "import",
    "inbox-arrow-down",
    "inbox-arrow-up",
    "inbox",
    "incognito",
    "indent",
    "infinity",
    "information-outline",
    "information-variant",
    "information",
    "instagram",
    "instapaper",
    "internet-explorer",
    "invert-colors",
    "itunes",
    "jeepney",
    "jira",
    "jsfiddle",
    "json",
    "keg",
    "kettle",
    "key-change",
    "key-minus",
    "key-plus",
    "key-remove",
    "key-variant",
    "key",
    "keyboard-backspace",
    "keyboard-caps",
    "keyboard-close",
    "keyboard-off",
    "keyboard-return",
    "keyboard-tab",
    "keyboard-variant",
    "keyboard",
    "kodi",
    "label-outline",
    "label",
    "lambda",
    "lamp",
    "lan-connect",
    "lan-disconnect",
    "lan-pending",
    "lan",
    "language-c",
    "language-cpp",
    "language-csharp",
    "language-css3",
    "language-html5",
    "language-javascript",
    "language-php",
    "language-python-text",
    "language-python",
    "language-swift",
    "language-typescript",
    "laptop-chromebook",
    "laptop-mac",
    "laptop-off",
    "laptop-windows",
    "laptop",
    "lastfm",
    "launch",
    "layers-off",
    "layers",
    "lead-pencil",
    "leaf",
    "led-off",
    "led-on",
    "led-outline",
    "led-variant-off",
    "led-variant-on",
    "led-variant-outline",
    "library-books",
    "library-music",
    "library-plus",
    "library",
    "lightbulb-on-outline",
    "lightbulb-on",
    "lightbulb-outline",
    "lightbulb",
    "link-off",
    "link-variant-off",
    "link-variant",
    "link",
    "linkedin-box",
    "linkedin",
    "linode",
    "linux",
    "lock-outline",
    "lock-plus",
    "lock-screen",
    "lock-unlocked-outline",
    "lock-unlocked",
    "lock",
    "login-variant",
    "login",
    "logout-variant",
    "logout",
    "looks",
    "loop",
    "loupe",
    "lumx",
    "magnet-on",
    "magnet",
    "magnify-minus",
    "magnify-plus",
    "magnify",
    "mail-ru",
    "mailbox",
    "map-marker-circle",
    "map-marker-minus",
    "map-marker-multiple",
    "map-marker-off",
    "map-marker-plus",
    "map-marker-radius",
    "map-marker",
    "map",
    "margin",
    "markdown",
    "marker-check",
    "marker",
    "martini",
    "material-ui",
    "matrix",
    "maxcdn",
    "medical-bag",
    "medium",
    "memory",
    "menu-down-outline",
    "menu-down",
    "menu-left",
    "menu-right",
    "menu-up-outline",
    "menu-up",
    "menu",
    "message-alert",
    "message-bulleted-off",
    "message-bulleted",
    "message-draw",
    "message-image",
    "message-outline",
    "message-plus",
    "message-processing",
    "message-reply-text",
    "message-reply",
    "message-settings-variant",
    "message-settings",
    "message-text-outline",
    "message-text",
    "message-video",
    "message",
    "meteor",
    "microphone-off",
    "microphone-outline",
    "microphone-settings",
    "microphone-variant-off",
    "microphone-variant",
    "microphone",
    "microscope",
    "microsoft",
    "minecraft",
    "minus-box-outline",
    "minus-box",
    "minus-circle-outline",
    "minus-circle",
    "minus-network",
    "minus",
    "mixcloud",
    "monitor-multiple",
    "monitor",
    "more",
    "mouse-off",
    "mouse-variant-off",
    "mouse-variant",
    "mouse",
    "move-resize-variant",
    "move-resize",
    "movie",
    "multiplication-box",
    "multiplication",
    "music-box-outline",
    "music-box",
    "music-circle",
    "music-note-bluetooth-off",
    "music-note-bluetooth",
    "music-note-eighth",
    "music-note-half",
    "music-note-off",
    "music-note-quarter",
    "music-note-sixteenth",
    "music-note-whole",
    "music-note",
    "nature-people",
    "nature",
    "navigation",
    "near-me",
    "needle",
    "nest-protect",
    "nest-thermostat",
    "new-box",
    "newspaper",
    "nfc-tap",
    "nfc-variant",
    "nfc",
    "no",
    "nodejs",
    "not-equal",
    "note-multiple-outline",
    "note-multiple",
    "note-outline",
    "note-plus-outline",
    "note-plus",
    "note-text",
    "note",
    "notification-clear-all",
    "npm",
    "nuke",
    "numeric-0-box-multiple-outline",
    "numeric-0-box-outline",
    "numeric-0-box",
    "numeric-1-box-multiple-outline",
    "numeric-1-box-outline",
    "numeric-1-box",
    "numeric-2-box-multiple-outline",
    "numeric-2-box-outline",
    "numeric-2-box",
    "numeric-3-box-multiple-outline",
    "numeric-3-box-outline",
    "numeric-3-box",
    "numeric-4-box-multiple-outline",
    "numeric-4-box-outline",
    "numeric-4-box",
    "numeric-5-box-multiple-outline",
    "numeric-5-box-outline",
    "numeric-5-box",
    "numeric-6-box-multiple-outline",
    "numeric-6-box-outline",
    "numeric-6-box",
    "numeric-7-box-multiple-outline",
    "numeric-7-box-outline",
    "numeric-7-box",
    "numeric-8-box-multiple-outline",
    "numeric-8-box-outline",
    "numeric-8-box",
    "numeric-9-box-multiple-outline",
    "numeric-9-box-outline",
    "numeric-9-box",
    "numeric-9-plus-box-multiple-outline",
    "numeric-9-plus-box-outline",
    "numeric-9-plus-box",
    "numeric",
    "nutriton",
    "oar",
    "octagon-outline",
    "octagon",
    "odnoklassniki",
    "office",
    "oil-temperature",
    "oil",
    "omega",
    "onedrive",
    "opacity",
    "open-in-app",
    "open-in-new",
    "openid",
    "opera",
    "ornament-variant",
    "ornament",
    "outbox",
    "outdent",
    "owl",
    "package-down",
    "package-up",
    "package-variant-closed",
    "package-variant",
    "package",
    "page-first",
    "page-last",
    "palette-advanced",
    "palette",
    "panda",
    "pandora",
    "panorama-fisheye",
    "panorama-horizontal",
    "panorama-vertical",
    "panorama-wide-angle",
    "panorama",
    "paper-cut-vertical",
    "paperclip",
    "parking",
    "pause-circle-outline",
    "pause-circle",
    "pause-octagon-outline",
    "pause-octagon",
    "pause",
    "paw-off",
    "paw",
    "pen",
    "pencil-box-outline",
    "pencil-box",
    "pencil-circle",
    "pencil-lock",
    "pencil-off",
    "pencil",
    "pentagon-outline",
    "pentagon",
    "people",
    "percent",
    "person-box",
    "person-minus",
    "person-plus",
    "pharmacy",
    "phone-bluetooth",
    "phone-classic",
    "phone-dots",
    "phone-forward",
    "phone-hangup",
    "phone-in-talk",
    "phone-incoming",
    "phone-locked",
    "phone-log",
    "phone-minus",
    "phone-missed",
    "phone-outgoing",
    "phone-paused",
    "phone-plus",
    "phone-voip",
    "phone",
    "pi-box",
    "pi",
    "piano",
    "picture",
    "pig",
    "pill",
    "pillar",
    "pin-off",
    "pin",
    "pine-tree-box",
    "pine-tree",
    "pinterest-box",
    "pinterest",
    "pistol",
    "pizza",
    "plane-shield",
    "plane",
    "play-box-outline",
    "play-circle-outline",
    "play-circle",
    "play-pause",
    "play-protected-content",
    "play",
    "playlist-check",
    "playlist-minus",
    "playlist-play",
    "playlist-plus",
    "playlist-remove",
    "playstation",
    "plex",
    "plus-box-outline",
    "plus-box",
    "plus-circle-multiple-outline",
    "plus-circle-outline",
    "plus-circle",
    "plus-network",
    "plus-one",
    "plus-outline",
    "plus",
    "pocket",
    "pokeball",
    "polaroid",
    "poll-box",
    "poll",
    "polymer",
    "pool",
    "popcorn",
    "pot-mix",
    "pot",
    "pound-box",
    "pound",
    "power-plug-off",
    "power-plug",
    "power-settings",
    "power-socket",
    "power",
    "prescription",
    "presentation-play",
    "presentation",
    "printer-3d",
    "printer-alert",
    "printer-settings",
    "printer",
    "priority-high",
    "priority-low",
    "professional-hexagon",
    "projector-screen",
    "projector",
    "publish",
    "pulse",
    "puzzle",
    "qqchat",
    "qrcode-scan",
    "qrcode",
    "quadcopter",
    "quality-high",
    "question-mark-circle",
    "quick-reply",
    "quicktime",
    "rabbit",
    "radar",
    "radiator",
    "radio-handheld",
    "radio-tower",
    "radio",
    "radioactive",
    "radiobox-blank",
    "radiobox-marked",
    "raspberrypi",
    "ray-end-arrow",
    "ray-end",
    "ray-start-arrow",
    "ray-start-end",
    "ray-start",
    "ray-vertex",
    "rdio",
    "react",
    "read",
    "readability",
    "receipt",
    "record-rec",
    "record",
    "recycle",
    "reddit",
    "redo-variant",
    "redo",
    "refresh",
    "relative-scale",
    "reload",
    "remote",
    "rename-box",
    "reorder-horizontal",
    "reorder-vertical",
    "repeat-off",
    "repeat-once",
    "repeat",
    "replay",
    "reply-all",
    "reply",
    "reproduction",
    "resize-bottom-right",
    "responsive",
    "restore",
    "rewind-outline",
    "rewind",
    "rhombus-outline",
    "rhombus",
    "ribbon",
    "road-variant",
    "road",
    "robot",
    "rocket",
    "roomba",
    "rotate-3d",
    "rotate-90",
    "rotate-left-variant",
    "rotate-left",
    "rotate-right-variant",
    "rotate-right",
    "rounded-corner",
    "router-wireless",
    "routes",
    "rowing",
    "rss-box",
    "rss",
    "ruler",
    "run",
    "sale",
    "satellite-variant",
    "satellite",
    "saxophone",
    "scale-balance",
    "scale-bathroom",
    "scale",
    "scanner",
    "school",
    "screen-rotation-lock",
    "screen-rotation",
    "screwdriver",
    "script",
    "sd",
    "seal",
    "seat-flat-angled",
    "seat-flat",
    "seat-individual-suite",
    "seat-legroom-extra",
    "seat-legroom-normal",
    "seat-legroom-reduced",
    "seat-recline-extra",
    "seat-recline-normal",
    "security-home",
    "security-network",
    "security",
    "select-all",
    "select-inverse",
    "select-off",
    "select",
    "send",
    "serial-port",
    "server-minus",
    "server-network-off",
    "server-network",
    "server-off",
    "server-plus",
    "server-remove",
    "server-security",
    "server",
    "settings-box",
    "settings",
    "shape-circle-plus",
    "shape-plus",
    "shape-polygon-plus",
    "shape-rectangle-plus",
    "shape-square-plus",
    "share-variant",
    "share",
    "shield-outline",
    "shield",
    "shopping-music",
    "shopping",
    "shovel-off",
    "shovel",
    "shredder",
    "shuffle-disabled",
    "shuffle-variant",
    "shuffle",
    "sigma-lower",
    "sigma",
    "sign-caution",
    "signal-2g",
    "signal-3g",
    "signal-4g",
    "signal-hspa-plus",
    "signal-hspa",
    "signal-variant",
    "signal",
    "silverware-fork",
    "silverware-spoon",
    "silverware-variant",
    "silverware",
    "sim-alert",
    "sim-off",
    "sim",
    "sitemap",
    "skip-backward",
    "skip-forward",
    "skip-next-circle-outline",
    "skip-next-circle",
    "skip-next",
    "skip-previous-circle-outline",
    "skip-previous-circle",
    "skip-previous",
    "skull",
    "skype-business",
    "skype",
    "slack",
    "sleep-off",
    "sleep",
    "smoking-off",
    "smoking",
    "snapchat",
    "snowflake",
    "snowman",
    "soccer",
    "sofa",
    "solid",
    "sort-alphabetical",
    "sort-ascending",
    "sort-descending",
    "sort-numeric",
    "sort-variant",
    "sort",
    "soundcloud",
    "source-branch",
    "source-commit-end-local",
    "source-commit-end",
    "source-commit-local",
    "source-commit-next-local",
    "source-commit-start-next-local",
    "source-commit-start",
    "source-commit",
    "source-fork",
    "source-merge",
    "source-pull",
    "speaker-off",
    "speaker-wireless",
    "speaker",
    "speedometer",
    "spellcheck",
    "spotify",
    "spotlight-beam",
    "spotlight",
    "spray",
    "spreadsheet",
    "square-inc-cash",
    "square-inc",
    "stackexchange",
    "stackoverflow",
    "stadium",
    "stairs",
    "star-circle",
    "star-half",
    "star-of-david",
    "star-off",
    "star-outline",
    "star",
    "steam",
    "steering",
    "step-backward-2",
    "step-backward",
    "step-forward-2",
    "step-forward",
    "stethoscope",
    "sticker",
    "stocking",
    "stop-circle-outline",
    "stop-circle",
    "stop",
    "store-24-hour",
    "store",
    "stove",
    "subdirectory-arrow-left",
    "subdirectory-arrow-right",
    "subway-variant",
    "subway",
    "sunglasses",
    "surround-sound",
    "svg",
    "swap-horizontal",
    "swap-vertical",
    "swim",
    "switch",
    "sword",
    "sync-alert",
    "sync-off",
    "sync",
    "tab-unselected",
    "tab",
    "table-column-plus-after",
    "table-column-plus-before",
    "table-column-remove",
    "table-column-width",
    "table-edit",
    "table-large",
    "table-row-height",
    "table-row-plus-after",
    "table-row-plus-before",
    "table-row-remove",
    "table",
    "tablet-android",
    "tablet-ipad",
    "tablet",
    "tag-faces",
    "tag-heart",
    "tag-multiple",
    "tag-outline",
    "tag-text-outline",
    "tag",
    "target",
    "taxi",
    "teamviewer",
    "telegram",
    "television-guide",
    "television",
    "temperature-celsius",
    "temperature-fahrenheit",
    "temperature-kelvin",
    "tennis",
    "tent",
    "terrain",
    "test-tube",
    "text-shadow",
    "text-to-speech-off",
    "text-to-speech",
    "textbox",
    "texture",
    "theater",
    "theme-light-dark",
    "thermometer-lines",
    "thermometer",
    "thumb-down-outline",
    "thumb-down",
    "thumb-up-outline",
    "thumb-up",
    "thumbs-up-down",
    "ticket-account",
    "ticket-confirmation",
    "ticket-percent",
    "ticket-star",
    "tie",
    "tilde",
    "tile-four",
    "timelapse",
    "timer-10",
    "timer-3",
    "timer-off",
    "timer-sand-empty",
    "timer-sand",
    "timer",
    "timetable",
    "toggle-switch-off",
    "toggle-switch-on",
    "tooltip-edit",
    "tooltip-image",
    "tooltip-outline-plus",
    "tooltip-outline",
    "tooltip-text",
    "tooltip",
    "tooth",
    "tor",
    "tower-beach",
    "tower-fire",
    "traffic-light",
    "train",
    "tram",
    "transcribe-close",
    "transcribe",
    "transfer",
    "transit-transfer",
    "translate",
    "trash",
    "treasure-chest",
    "tree",
    "trello",
    "trending-down",
    "trending-neutral",
    "trending-up",
    "triangle-outline",
    "triangle",
    "trophy-outline",
    "trophy-variant-outline",
    "truck-delivery",
    "truck-trailer",
    "truck",
    "tshirt-crew",
    "tshirt-v",
    "tumblr-reblog",
    "tumblr",
    "tune-vertical",
    "tune",
    "twitch",
    "twitter-box",
    "twitter-circle",
    "twitter-retweet",
    "twitter",
    "ubuntu",
    "umbraco",
    "umbrella-outline",
    "umbrella",
    "undo-variant",
    "undo",
    "unfold-less",
    "unfold-more",
    "ungroup",
    "unity",
    "untappd",
    "update",
    "upload",
    "usb",
    "vector-arrange-above",
    "vector-arrange-below",
    "vector-circle-variant",
    "vector-circle",
    "vector-combine",
    "vector-curve",
    "vector-difference-ab",
    "vector-difference-ba",
    "vector-difference",
    "vector-intersection",
    "vector-line",
    "vector-point",
    "vector-polygon",
    "vector-polyline",
    "vector-rectangle",
    "vector-selection",
    "vector-square",
    "vector-triangle",
    "vector-union",
    "verified",
    "vibration",
    "video-off",
    "video-switch",
    "video",
    "view-agenda",
    "view-array",
    "view-carousel",
    "view-column",
    "view-dashboard",
    "view-day",
    "view-headline",
    "view-list",
    "view-module",
    "view-parallel",
    "view-quilt",
    "view-sequential",
    "view-stream",
    "view-week",
    "vimeo",
    "vine",
    "violin",
    "visualstudio",
    "vk-box",
    "vk-circle",
    "vk",
    "vlc",
    "voice",
    "voicemail",
    "volume-high",
    "volume-low",
    "volume-medium",
    "volume-off",
    "volume",
    "vpn",
    "walk",
    "wallet-giftcard",
    "wallet-membership",
    "wallet-travel",
    "wallet",
    "wan",
    "washing-machine",
    "watch-export",
    "watch-import",
    "watch-vibrate",
    "watch",
    "water-off",
    "water-percent",
    "water-pump",
    "water",
    "watermark",
    "weather-cloudy",
    "weather-fog",
    "weather-hail",
    "weather-lightning-rainy",
    "weather-lightning",
    "weather-night",
    "weather-partlycloudy",
    "weather-pouring",
    "weather-rainy",
    "weather-snowy-rainy",
    "weather-snowy",
    "weather-sunny",
    "weather-sunset-down",
    "weather-sunset-up",
    "weather-sunset",
    "weather-windy-variant",
    "weather-windy",
    "web",
    "webcam",
    "webhook",
    "webpack",
    "wechat",
    "weight-kilogram",
    "weight",
    "whatsapp",
    "wheelchair-accessibility",
    "white-balance-auto",
    "white-balance-incandescent",
    "white-balance-irradescent",
    "white-balance-sunny",
    "widgets",
    "wifi-off",
    "wifi",
    "wii",
    "wiiu",
    "wikipedia",
    "window-close",
    "window-closed",
    "window-maximize",
    "window-minimize",
    "window-open",
    "window-restore",
    "windows",
    "wordpress",
    "worker",
    "wrench",
    "wunderlist",
    "xaml",
    "xbox-controller-off",
    "xbox-controller",
    "xbox",
    "xda",
    "xing-box",
    "xing-circle",
    "xing",
    "xml",
    "yeast",
    "yelp",
    "yin-yang",
    "youtube-play",
    "youtube",
    "zip-box"
  ]
}
